export default __webpack_public_path__ + "static/media/icon_facility_charger.fe245703.svg";